
import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants';
import { getGlobalCookie, setGlobalCookie, setGlobalTimeCookie } from '../../utils';
export default function DeploymentMessage({ marginbottom, margin }) {
    const [deploymentFlag, setDeploymentFlag] = useState(false)
    const [bannerData, setBannerData] = useState(null)
    const getInfo = () => {
        fetch(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/maintenance_banner/info.json?timestamp=${new Date().getTime()}`)
            .then(res => res.json())
            .then(resp => {
                const dismissed = JSON.parse(getGlobalCookie('showBanner') || '{}')
                if (resp?.for_maintenance && (resp?.id !== dismissed?.maintenance || !dismissed?.maintenance)) {
                    setDeploymentFlag(resp?.for_maintenance)
                    setBannerData(resp)
                } else {
                    return
                }
            })
            .catch(() => { })
    }

    useEffect(() => {
        getInfo()
        //URL will be called in every 6 hours 
        const interval = setInterval(getInfo, (6 * 60 * 60 * 1000))
        return () => clearInterval(interval)
    }, [])

    const getClientData = () => {
        let oldCookie = JSON.parse(getGlobalCookie('showBanner'))
        let maintenanceCookie = { maintenance: bannerData?.id }
        setGlobalCookie('showBanner', JSON.stringify({ ...oldCookie, ...maintenanceCookie }), 3)
    }
    return (
        <>
            {deploymentFlag && bannerData ?
                <Grid item sm="12">
                    <p className="deployment-info" style={marginbottom ? { marginBottom: marginbottom } : null}>
                        <span>{bannerData.message}</span>
                        <span >
                            <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                        </span>
                    </p>
                </Grid>
                :
                null
            }
        </>
    )
}

